import React from "react";
import { css } from "glamor";
import LobbyLayout from "../lobby/LobbyLayout";
import Link from "../library/Link";
import Button from "../library/Button";
import { CardForm, TextField } from "../library/forms";
import { spacing, typographyColors } from "../library/theme";

const linkClass = css({
  color: typographyColors.defaultLink,
  fontWeight: '500',
  textTransform: 'uppercase',
  display: 'block',
  paddingTop: 20,
  "&:hover": { color: "rgba(0,0,0, 0.5)" },
});
const buttonMargin = css({ marginTop: spacing.m });
const textStyle = { textAlign: 'left', display: 'block' };

export default function SignInForm(props) {
  return (
    <LobbyLayout>
      <CardForm onSubmit={props.handleSubmit} error={props.error}>
        <p style={textStyle}>Enviaremos as instruções para recuperar sua senha através do seu e-mail cadastrado.</p>
        <TextField
          className={buttonMargin}
          name="email"
          type="email"
          placeholder="E-mail"
          required
          fluid
        />
        <div className={buttonMargin}>
          <Button
            color="red"
            disabled={props.pristine || props.submitting}
            size="large"
            fluid
          >
            RECUPERAR SENHA
          </Button>
        </div>
      </CardForm>
      <Link to="/signin" className={linkClass}>
        Voltar para o login
      </Link>
    </LobbyLayout>
  );
}
